// #region
export var ProvisionTypes;
(function (ProvisionTypes) {
    ProvisionTypes["Commission"] = "Commission";
    ProvisionTypes["Decommission"] = "Decommission";
    ProvisionTypes["Planned"] = "Planned";
})(ProvisionTypes || (ProvisionTypes = {}));
// #endregion
